import React from 'react';
import { AnimatedSection } from './AnimatedSection';
type Kpi = {
  val: string;
  label: string;
  detail: string;
};
const kpis: Kpi[] = [{
  val: '1.500.000',
  label: 'Ordini gestiti',
  detail: 'Volumi cumulati gestiti da Aisac in produzione, sull’insieme dei clienti attivi.'
}, {
  val: '−85%',
  label: 'Giacenze e mancate consegne',
  detail: 'Riduzione media del tasso di giacenza e di non consegna grazie a tracking, validazione dati e gestione attiva del giorno di consegna.'
}, {
  val: '+25%',
  label: 'ROAS post-consegna',
  detail: 'Aumento del ritorno sulla spesa pubblicitaria grazie agli up-selling automatici post-acquisto orchestrati da Aisac.'
}, {
  val: '€ 250k',
  label: 'Fatture errate recuperate',
  detail: 'Importo recuperato su un singolo cliente attraverso la verifica automatica di sovrapprezzi e costi nascosti.'
}];
export function CaseStudy() {
  return <section className="section-pad border-t border-default" id="numeri" data-id="element-18">
      <div className="wrap" data-id="element-19">
        <AnimatedSection delay={0} data-id="element-20">
          <div className="section-tag section-tag--accent mb-6" data-id="element-21">I numeri</div>

          <h2 className="text-display-section mb-6 max-w-[24ch]" data-id="element-22">
            L’impatto reale di Aisac,{' '}
            <strong className="color-ink-primary font-medium" data-id="element-23">
              misurato in produzione.
            </strong>
          </h2>

          <p className="text-body-xl color-ink-secondary max-w-[720px]" data-id="element-24">
            Risultati aggregati sui clienti Aisac attivi. Volumi cumulati e
            variazioni medie sui KPI di delivery. Non promesse: numeri.
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-[var(--s-12)]" data-id="element-25">
          {kpis.map((kpi, i) => <AnimatedSection key={kpi.label} delay={0.05 + i * 0.05} data-id="element-26">
              <div className="rounded-lg border border-default bg-[#0a0a0a] p-6 md:p-7 h-full flex flex-col" data-id="element-27">
                <div className="mb-3 tabular-nums" style={{
              color: 'var(--accent-500)',
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(30px, 3.2vw, 40px)',
              fontWeight: 500,
              lineHeight: 1.0,
              letterSpacing: '-0.02em'
            }} data-id="element-28">
                  {kpi.val}
                </div>

                <div className="color-ink-primary mb-2" style={{
              fontFamily: 'var(--font-display)',
              fontSize: '17px',
              fontWeight: 500,
              lineHeight: 1.25,
              letterSpacing: '-0.01em'
            }} data-id="element-29">
                  {kpi.label}
                </div>

                <div className="text-body-sm color-ink-secondary leading-relaxed" data-id="element-30">
                  {kpi.detail}
                </div>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}